import React, { useState } from "react";
import logo from "../../assets/legacy grey.png";
import { useNavigate } from "react-router-dom";
import { admin_base_url } from "../../Global";
import { useAuth } from "../../context/AuthContext";
import {
  Box,
  Typography,
  InputBase,
  ButtonBase,
  Link,
  IconButton,
  InputAdornment,
} from "@mui/material";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(admin_base_url + `/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (!response.ok)
        throw new Error(data.message || "Invalid email or password");

      const { token } = data;

      const jwtPayload = JSON.parse(atob(token.split(".")[1]));
      await login(token, jwtPayload, data);
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="w-full relative px-[20px] pt-[50px] pb-[50px] h-[100vh] text-left text-[1.125rem] text-white font-gilroy bg-gray-400 shadow-[0px_4px_74px_rgba(0,_0,_0,_0.25)] overflow-hidden flex flex-col items-center justify-start box-border gap-[1rem] tracking-[normal] mq700:gap-[1rem] mq950:flex-wrap mq975:gap-[1rem]">
      <Box
        component="form"
        onSubmit={handleSubmit}
        className="m-0 rounded-3xl bg-gray-200 flex flex-col items-center justify-start mt-10 pt-[1.75rem] pb-[2.13rem] pr-[2.94rem] pl-[3rem] box-border gap-[1rem] max-w-full z-[2] mq700:pl-[1.5rem] mq700:pr-[1.44rem] mq700:box-border mq950:pt-[1.25rem] mq950:pb-[1.38rem] mq950:box-border"
      >
        <Box className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
          <Box
            component="img"
            className="w-[150px] h-[36px] relative z-[3]"
            loading="eager"
            alt=""
            src={logo}
          />

          <Typography
            component="h1"
            className="m-0 flex-1 relative text-inherit leading-[2.375rem] capitalize font-bold font-inherit flex items-center z-[1] mq925:text-[1.875rem] mq925:leading-[1.875rem] mq450:text-[1.438rem] mq450:leading-[1.438rem]"
          >
            Login
          </Typography>

          <Box className="self-stretch flex flex-col items-start justify-start pt-[0.25rem] px-[0rem] pb-[1.19rem] relative gap-[0.25rem] z-[3]">
            <Box className="h-[19px] relative leading-[18px] capitalize flex items-center shrink-0 z-[1]">
              Email
            </Box>
            <InputBase
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-gray-500 self-stretch h-[48px] rounded-3xs flex flex-row items-start justify-start py-[13px] px-[18px] box-border font-gilroy font-light text-[1.125rem] text-gray-400 min-w-[300px] z-[1]"
              placeholder="Enter your Email"
            />
          </Box>
          <Box className="self-stretch flex flex-col items-start justify-start pt-[0.25rem] px-[0rem] pb-[0.19rem] relative gap-[0.25rem] z-[3]">
            <Box className="h-[19px] relative leading-[18px] capitalize flex items-center shrink-0 z-[1]">
              password
            </Box>
            <InputBase
              className="w-full bg-gray-500 self-stretch h-[48px] rounded-3xs flex flex-row items-start justify-start py-[13px] px-[18px] box-border font-gilroy font-light text-[1.125rem] text-gray-800 min-w-[250px] z-[1]"
              placeholder="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    style={{ color: "#9ca3af" }}
                  >
                    {showPassword ? (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                        <line x1="1" y1="1" x2="23" y2="23"></line>
                      </svg>
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
          </Box>
        </Box>

        <Box className="self-stretch flex-1 flex flex-col items-start justify-start max-w-full">
          {error && (
            <Box
              style={{
                width: "100%",
                borderRadius: "8px",
                padding: "10px 14px",
                marginBottom: "8px",
                background: "rgba(239,68,68,0.12)",
                border: "1px solid rgba(239,68,68,0.3)",
              }}
            >
              <Typography
                style={{
                  color: "#f87171",
                  fontSize: "13px",
                  fontFamily: "Gilroy, sans-serif",
                }}
              >
                {error}
              </Typography>
            </Box>
          )}
          <ButtonBase
            type="submit"
            disabled={loading}
            className="no-underline cursor-pointer bg-white self-stretch my-4 rounded-lg flex flex-row items-center justify-center box-border max-w-full whitespace-nowrap z-[3] hover:bg-chocolate"
            style={{ opacity: loading ? 0.7 : 1 }}
          >
            <Box className="relative text-[20px] leading-[40px] text-gray-200 capitalize font-semibold font-poppins text-left z-[4]">
              {loading ? "Signing in…" : "Sign In"}
            </Box>
          </ButtonBase>
          <Box className="self-stretch flex flex-col items-center justify-start max-w-full z-[3]">
            <Link
              component="button"
              type="button"
              onClick={() => navigate("/forgot-password")}
              className="text-white text-[1rem] font-gilroy underline cursor-pointer"
            >
              Forgot Password?
            </Link>
          </Box>
          <ButtonBase onClick={() => navigate("/register")}>
            <Box className="text-white text-[1rem] font-gilroy underline cursor-pointer">
              Request Admin Access
            </Box>
          </ButtonBase>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
